var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00004 13H18V2H2.00004V13ZM11 15V17H15V19H5.00004V17H9.00004V15H0.992041C0.860727 14.9992 0.730858 14.9725 0.609879 14.9215C0.488899 14.8704 0.379188 14.7959 0.287032 14.7024C0.194877 14.6088 0.122089 14.498 0.0728414 14.3763C0.0235937 14.2546 -0.00114581 14.1243 4.07459e-05 13.993V1.007C4.07459e-05 0.451 0.455041 0 0.992041 0H19.008C19.556 0 20 0.449 20 1.007V13.993C20 14.549 19.545 15 19.008 15H11Z",
    fill: "#5B73E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenIcon);
export default __webpack_public_path__ + "static/media/screen-icon.319de8772cbca7f53e0698437ce48994.svg";
export { ForwardRef as ReactComponent };